module.exports = __webpack_public_path__ + "img/orange-and-red-lily.33f864ef.jpg";